import { Fragment, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
//--------------------------------------------------------------------------------------------
import Resize from "src/components/common/resize";
import magnifierImg from "src/img/magnifier.png";
import Footer from "src/components/common/frame/footer";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
import { myOptions, myAccessOptions } from "./userForm";
import Thumbnail from "src/components/common/thumbnail";
import { useMyStore } from "src/components/main/mainStore";
import {
    boolAndReducer, 
    MyFormData, 
    myAxios, 
    scroll, 
    getTimeStamp, 
    testerEmails,
    isDevMode,
    appTitle, 
} from "src/components/common/functions";
import SettingsForm from "./settingForm";
import Export from "./export";
import BirthDayForm from "./birthdayForm";
import FilterForm from "./filter";
import Detail from "./detail";
import DispatchForm from "./dispatchForm";
import UserForm from "./userForm";
//--------------------------------------------------------------------------------------------
const title = "Personnel";
export default function Personnel({ tabTitle }){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const curUser = useMyStore(state => state.user);
    const colorCode = (user) => {
        if(user.dispatch === "1") return "grey";
        if(user.verificationCode !== "") return "yellow";
    }
    const [updateDateTime, setUpdateDateTime] = useState(getTimeStamp());
    //--------------------------------------------------------------------------------------------
    const defaultFilter = {
        curEE: "Yes", 
        mine: false, 
        googleAccount: "All",
        hireMin: "", hireMax: "",
        quitMin: "", quitMax: "",
        birthDayMin: "", birthDayMax: "",
        ...Object.fromEntries(Object.keys(myOptions).map(key => [key, "All"])),
        unionName: "All",
        ...Object.fromEntries(Object.keys(myAccessOptions).map(key => [key, "All"]))
    };
    const [showFilter, setShowFilterForm] = useState(false);
    const [curFilter, setFilter] = useState(defaultFilter);
    const [userList, setUserList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);   
    const [showBalance, setShowBalanceForm] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [filterWords, setFilterWords] = useState("");
    const [showLoading, setShowLoading] = useState(false);
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const location = useLocation();
    //--------------------------------------------------------------------------------------------
    const id = location.pathname.split("/")[2];
    const idid = location.pathname.split("/")[3];
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filterUserList = userList.length?userList.map(u => ({
        ...u, 
        userName: u.firstName + " " + u.middleName + " " + u.lastName,
        creator: userList.filter(uu => uu.email === u.creatorEmail)
            .map(u => ({
                ...u, 
                userName: u.firstName + " " + u.middleName + " " + u.lastName
            }))[0]?.userName,
        updater: userList.filter(uu => uu.email === u.updaterEmail)
            .map(u => ({
                ...u, 
                userName: u.firstName + " " + u.middleName + " " + u.lastName
            }))[0]?.userName,
    }))
    .filter(u => 
        (curFilter.curEE === "All"?true:(curFilter.curEE === "Yes"?!u.quitDate:u.quitDate))
        && (!curFilter.mine || (curFilter.mine && u.creatorEmail === curUser.email))
        && (curFilter.googleAccount === "All"?true:u.googleAccount === curFilter.googleAccount)
        && (curFilter.hireMin?new Date(u.hireDate.replace(/-/g, "/")) >= new Date(curFilter.hireMin.replace(/-/g, "/")):true)
        && (curFilter.hireMax?new Date(u.hireDate.replace(/-/g, "/")) <= new Date(curFilter.hireMax.replace(/-/g, "/")):true)
        && (curFilter.quitMin && u.quitDate?new Date(u.quitDate.replace(/-/g, "/")) >= new Date(curFilter.quitMin.replace(/-/g, "/")):true)
        && (curFilter.quitMax && u.quitDate?new Date(u.quitDate.replace(/-/g, "/")) <= new Date(curFilter.quitMax.replace(/-/g, "/")):true)
        && (curFilter.birthDayMin && u.birthDay?new Date(u.birthDay.replace(/-/g, "/")) >= new Date(curFilter.birthDayMin.replace(/-/g, "/")):true)
        && (curFilter.birthDayMax && u.birthDay?new Date(u.birthDay.replace(/-/g, "/")) <= new Date(curFilter.birthDayMax):true)
        //basic Information
        && Object.keys(myOptions).map(key => curFilter[key] === "All"?true:u[key] === curFilter[key]).reduce(boolAndReducer, true)
        //access control
        && Object.keys(myAccessOptions).map(key => curFilter[key] === "All"?true:u[key] === curFilter[key]).reduce(boolAndReducer, true)
        //simple filter
        && (filterWords.toLowerCase().split(" ").map(f => JSON.stringify(
            Object.values(u)
        ).toLowerCase().indexOf(f) > -1).reduce(boolAndReducer, true))
    )
    :[];
    const currentUserList = filterUserList.slice(indexOfFirstItem, indexOfLastItem);
    const pageNumbers = Array.from({length: Math.ceil(filterUserList.length / itemsPerPage)}, (_, i) => (i + 1));
    //--------------------------------------------------------------------------------------------
    const deleteUser = async e => {
        if(window.confirm("If the user is left, you can set a left date when edit. Do you still want to delete this user?")){
            const formData = new MyFormData();
            formData.append("userEmail", e.currentTarget.id);
            formData.append("googleCalendar", e.currentTarget.googlecalendar);
            //-----------------------------------
            setShowLoader(true);
            const res = await myAxios("users/deleteUser.php", formData);
            setShowLoader(false);
            if(!res) return;
            //-----------------------------------
            setUserList(res.data);
            history.replace(`/${title}`);
            scroll(null);
        }
    }
    const handleSubmit = async e => {
        e.preventDefault();
        const formData = new MyFormData(e.currentTarget);
        const userEmail = formData.get("userEmail");
        // if(formData.get("keyword") === "Add" && (!userEmail.toLocaleLowerCase().endsWith("@besstestlab.com") && !userEmail.toLocaleLowerCase().endsWith("@bessus.com"))){
        //     window.alert("the email must be Bess Email.");
        //     return;
        // }
        if(formData.get("curOffice") === "yes" && formData.get("office") === "no"){
            if(!window.confirm("Are you sure to remove the access of office time card?\nThis action will remove all the time card data of this user.")){
                return;
            }
        }
        if(formData.get("curOutside") !== "no" && formData.get("curOutside") && formData.get("outside") === "no"){
            if(!window.confirm("Are you sure to remove the access of outside time card?\nThis action will remove all the time card data of this user.")){
                return;
            }
        }
        //-----------------------------------
        setShowLoader(true);
        const res = await myAxios(formData.get("url"), formData);
        setShowLoader(false);
        if(!res) return;
        //-----------------------------------
        setUserList(res.data);
        history.push(`/${title}`);
    }
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        let isMounted = true;
        const id = history.location.pathname.split("/")[2];
        const getData = async () => {
            if(isDevMode) console.log("useEffect main");
            //-----------------------------------
            setShowLoading(true);
            const res = await myAxios("users/readUsers.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!res) return;
            //-----------------------------------
            setUserList(res.data);
            if(!res.data.find(u => id === u.email)){
                switch(id){
                    case "Add":
                        return; 
                    case undefined:
                        return
                    default:
                }
                history.replace(`/${title}`);
                return;
            }
        }
        getData()
        return () => {isMounted = false;}
    },[history, updateDateTime])
    useEffect(() => {
        if(isDevMode) console.log("useEffect paginate");
        const filterUserList = userList.length?userList.filter(localUser => !localUser.quitDate):[];
        const thisUser = filterUserList.find(localUser => id === localUser.email);
        if(!thisUser) return;
        const hashkeys = filterUserList.map(localUser => localUser.email);
        setCurrentPage(Math.ceil((hashkeys.indexOf(id) + 1) / itemsPerPage));
        scroll(id);
    }, [userList, itemsPerPage])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: curUser.userTheme}}>
                <span>
                    <Resize/>
                    {title}
                    <span data-toggle = "tooltip" title = {"Refreshed on " + updateDateTime} className = "btn btn-primary py-1 ml-4" onClick = {() => setUpdateDateTime(getTimeStamp())}>↻</span>
                </span>
                <span>
                    <input
                        className = "form-control w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                            setCurrentPage(1);
                        }}
                    />
                    <img alt = "" src = {magnifierImg}/>
                </span>
                <span className = "pointer" onClick = {() => {setShowBalanceForm(true)}}>BirthDay</span>
                {showBalance?
                <BirthDayForm
                    closeIt = {() => setShowBalanceForm(false)}
                    filterUserList = {filterUserList}
                />:null}
                <span className = "pointer" onClick = {() => {setShowSettings(true)}}>Settings</span>
                {showSettings?
                <SettingsForm
                    closeIt = {() => setShowSettings(false)}
                    filterUserList = {filterUserList}
                />:null}
                <span className = "pointer rounded p-1" style = {{
                    background:Object.entries(curFilter).filter(([key, value]) => defaultFilter[key] !== value).length?
                    "rgb(0,123,255)"
                    :null
                }} onClick = {() => {setShowFilterForm(true)}}>
                    Filter
                </span>
                {showFilter?
                <FilterForm
                userList = {userList}
                setCurrentPage = {setCurrentPage}
                curFilter = {curFilter}
                setFilter = {setFilter}
                closeIt = {() => setShowFilterForm(false)}
                defaultFilter = {defaultFilter}
                />:null}
                <Export
                    filterUserList = {filterUserList}
                />
                {curUser.personel === "yes" || curUser.personel === "outside"?<>
                <span className = "pointer" onClick = {() => {history.push(`/${title}/Add`);}}>Add</span>
                {id === "Add"?<UserForm keyword = "Add" handleSubmit = {handleSubmit} closeIt = {() => history.push(`/${title}`)} shouldDisable = {false} postUrl = "users/createUser.php"/>:null}
                </>:null}
                {curUser.personel === "dispatch"?<>
                <span className = "pointer" onClick = {() => {history.push(`/${title}/AddDispatch`);}}>Add Dispatch</span>
                {id === "AddDispatch"?<DispatchForm keyword = "Add Dispatch" handleSubmit = {handleSubmit} closeIt = {() => history.push(`/${title}`)} shouldDisable = {false} postUrl = "users/createUser.php"/>:null}
                </>:null}
            </div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !filterUserList.length?<div className = "cssLoading">Empty</div>:
                <div className = "table-responsive">
                    <table className = "table">
                        <thead className = "noTableTopBorder">
                            <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Email Address</th>
                                <th>Mobile Phone</th>
                                <th>Work Phone</th>
                                <th>Office Extension</th>
                                <th>Region</th>
                                <th>Department</th>
                                <th>Role</th>
                                <th>Version</th>
                                <th>Safety Code</th>
                            </tr>
                        </thead>
                        <tbody>
                           {currentUserList.map((user, key) =>
                            <Fragment key = {key}>
                            <tr className = "pointer" id = {user.email} style = {{
                                backgroundColor: colorCode(user)
                            }} 
                                onClick = {e => {
                                    if(!e.target.id){
                                        if(id !== e.currentTarget.id){
                                            history.push(`/${title}/${e.currentTarget.id}`);
                                            scroll(e.currentTarget.id);
                                        }else{
                                            history.push(`/${title}`);
                                            scroll(null);
                                        }
                                    }
                                }}
                            >
                                <td className = {id === user.email?"showMinus":"showPlus"}></td>
                                <td>
                                <Thumbnail
                                    value = {user.thumbnail}
                                    side = {100}
                                /> {user.firstName} {user.middleName} {user.lastName}</td>
                                <td className = "user-select-text">
                                    <a href = {`mailto:${user.email}`}>
                                        {user.email}
                                    </a></td>
                                <td>
                                    <a href = {`tel:${user.phoneNumber}`}>
                                        {user.phoneNumber}
                                    </a>
                                </td>
                                <td>{user.workPhone}</td>
                                <td>{user.extension}</td>
                                <td>{user.region}</td>  
                                <td>{user.department}</td>
                                <td>{user.role}</td>
                                <td>{user.version}</td>
                                <td>{user.safetyCodeText}</td>
                            </tr>
                            <tr>
                                <td className = "noborder" colSpan = {100}>
                                    <TransitionWidthHeight
                                        classNames = "cssTDTransition"
                                        In = {history.location.pathname.split("/")[2] ===  user.email}
                                    >
                                        <Detail
                                            id = {id}
                                            idid = {idid}
                                            setUserList = {setUserList}
                                            userList = {userList}
                                            user = {user}
                                            history = {history}
                                            deleteUser = {deleteUser}
                                            handleSubmit = {handleSubmit}
                                        />
                                    </TransitionWidthHeight>
                                </td>
                            </tr>
                            </Fragment>)}
                        </tbody>
                    </table>
                </div>}
                {!showLoading && filterUserList.length?
                <Footer
                    length = {filterUserList.length}
                    pageNumbers = {pageNumbers}

                    currentPage = {currentPage}
                    setCurrentPage = {setCurrentPage}
                    itemsPerPage = {itemsPerPage}
                    setItemsPerPage = {setItemsPerPage}
                />
                :null}
            </div>
        </div>
    )
}